__turbopack_context__.v({
  "search_pagination_list_item_button": "hRQghG_search_pagination_list_item_button",
  "search_pagination_list_item_button_selected": "hRQghG_search_pagination_list_item_button_selected",
});
